// extracted by mini-css-extract-plugin
export var activityContainer = "_n4-0";
export var typingIndicatorContainer = "_n4-1";
export var typingIndicatorDot = "_n4-2";
export var wave = "_n4-3";